const constants = {
  URL_API: 'https://apistest.ccpll.org',
  ACCESS_TOKEN_KEY: 'access_token',
  REFRESH_TOKEN_KEY: 'refresh_token',
  ACCESS_TOKEN_EXPIRES_IN: 'expires_in',
  ACCESS_TOKEN_EXPIRES_AT: 'expires_at',
  USUARIO_ID: 'USUARIO_ID',
  API_VERSION: 'v1',
  URL_CUENTA_CONTASISCORP: 'https://micontasis.smartbusinessdev.com',
  URL_NEGOCIOS: 'https://ea7f3970-9050-11ec-8731-9b3fb3ce7053.negociosonline.smartbusinessdev.com',
  EMPRESA_ID: '9a36d900-9051-11ec-b222-ff9896753092',
};

const exportedObject = {
  constants,
};

export default exportedObject;
